



import { createBrowserRouter } from "react-router-dom";

import Home from "../pages/Home";
import Preview from "../pages/Preview";
import Edit from "../pages/Edit";
import Setting from '../pages/Setting';
import JotFormSign from "../pages/JotFormSign";
import Notification from "../pages/Notification";
import Publish from "../pages/Publish";
import EmailSetting from "../pages/EmailSetting";
import EmailSettingOptions from "../pages/EmailSettingOptions";
import Condition from "../pages/Condition";
import ShowAndHide from "../pages/ShowAndHide";
import UpdateAndCalculate from "../pages/UpdateAndCalculate";
import EnableAndRequire from "../pages/EnableAndRequire";
import Skip from "../pages/Skip";
import ThankYou from "../pages/ThankYou";
import EmailRecipient from "../pages/EmailRecipient";
import FormSetting from '../pages/FormSetting';
import Approval from "../pages/Approval";
import SettingThankYou from "../pages/SettingThankYou";
import NotificationEmail from "../pages/NotificationEmail";
import AutoresponderEmail from "../pages/AutoresponderEmail";
import FormWarnings from "../pages/FormWarnings";
// import CustomizeSaveEmail from "../pages/CustomizeSaveEmail";
import EmailTab from "../pages/EmailTab";
import AdvanceTab from "../pages/AdvanceTab";
import SenderNotificationEmail from "../pages/SenderNotificationEmail";
import AdvanceNotificationEmail from "../pages/AdvanceNotificationEmail";
import AutoresponderEmailSender from "../pages/AutoresponderEmailSender";
import AutoresponderEmailAdvance from "../pages/AutoresponderEmailAdvance";
import ConditionList from "../pages/ConditionList";
import Main from "../pages/Main";
import CreateForm from "../pages/CreateForm";
import ScratchCreateFormMainPage from "../pages/ScratchCreateFormMainPage";
import TemplateMainPage from "../pages/TemplateMainPage";
import ImportForm from "../pages/ImportForm";
import CloneExistingForm from "../pages/CloneExistingForm";
import Login from "../pages/Login";
import ForgetPassword from "../pages/ForgetPassword";
import FillForm from "../pages/FillForm";
import ResponseFormPage from "../pages/ResponseFormPage";
import DetailsResponseForm from "../pages/DetailsResponseForm";




const router = createBrowserRouter([
    {
        path: "/",
        element: <Login/>,
    },
    {
        path: "/register",
        element: <Login/>,
    },
    {
        path: "/main",
        element: <Main/>,
    },
    {
        path: "/forget-password",
        element: <ForgetPassword/>,
    },
    {
        path: "/build/:id",
        element: <Home state={true}/>,
    },
    {
        path: "/card-form/build/:id",
        element: <Home state={true}/>,
    },
    {
        path: "/create-form",
        element: <CreateForm/>,
    },
    {
        path: "/create-form/scratch",
        element: <ScratchCreateFormMainPage/>,
    },
    {
        path: "/create-form/template",
        element: <TemplateMainPage/>,
    },
    {
        path: "/create-form/import",
        element: <ImportForm/>,
    },
    {
        path: "/create-form/import-form/clone-existing-form",
        element: <CloneExistingForm/>,
    },
    {
        path: "/edit",
        element: <Home state={true}/>,
    },
    {
        path: "/preview",
        element: <Preview />,
    },
    {
        path: "/publish/:id",
        element: <Publish />,
    },
    {
        path: "/card-form/publish/:id",
        element: <Publish />,
    },
    {
        path: "/edit-form",
        element: <Edit />,
    },
    {
        path: "/setting/:id",
        element: <Setting />,
    },
    {
        path: "/settings/general/:id",
        element: <FormSetting />,
    },
    {
        path: "/setting/sign/:id",
        element: <JotFormSign />,
    },
    {
        path: "/setting/notification/:id",
        element: <Notification />,
    },
    {
        path: "/setting/email/:id",
        element: <EmailSetting />,
    },

    {
        path: "/setting/email/options/:id",
        element: <EmailSettingOptions />,
    },
    {
        path: "/setting/conditional/:id",
        element: <Condition />,
    },
    {
        path: "/setting/conditional/show-and-hide/:id",
        element: <ShowAndHide />,
    },
    {
        path: "/setting/conditional/update-calculate/:id",
        element: <UpdateAndCalculate />,
    },
    {
        path: "/setting/conditional/enable-require/:id",
        element: <EnableAndRequire />,
    },
    {
        path: "/setting/conditional/skip/:id",
        element: <Skip />,
    },
    {
        path: "/setting/conditional/thankyou/:id",
        element: <ThankYou />,
    },
    {
        path: "/setting/conditional/email-recipient/:id",
        element: <EmailRecipient />,
    },
    {
        path: "/setting/apprival/:id",
        element: <Approval />,
    },
    {
        path: "/setting/thankyou/:id",
        element: <SettingThankYou />,
    },
    {
        path: "/setting/email-setting/notification-email/:id",
        element: <NotificationEmail />,
    },
    {
        path: "/setting/email-setting/notification-email/sender/:id",
        element: <SenderNotificationEmail />,
    },
    {
        path: "/setting/email-setting/notification-email/advance/:id",
        element: <AdvanceNotificationEmail />,
    },
    {
        path: "/setting/email-setting/auto-responder-email/:id",
        element: <AutoresponderEmail />,
    },
    {
        path: "/setting/email-setting/auto-responder-email/sender/:id",
        element: <AutoresponderEmailSender />,
    },
    {
        path: "/setting/email-setting/auto-responder-email/advance/:id",
        element: <AutoresponderEmailAdvance />,
    },
    {
        path: "/setting/general/form-warnings/:id",
        element: <FormWarnings />,
    },
    {
        path: "/setting/general/customize-save-email/:id",
        element: <EmailTab />,
    },
    {
        path: "/setting/general/customize-save-email/advance/:id",
        element: <AdvanceTab />,
    },
    {
        path: "/setting/condition-list/:id",
        element: <ConditionList />,
    },
    {
        path: "/user/fill-form/:id",
        element: <FillForm />,
    },
    {
        path: "/form/response-list/:id",
        element: <ResponseFormPage />,
    },
    {
        path: "/form/details-response-form/:id",
        element: <DetailsResponseForm />,
    },
])
export default router